import { Component } from '@angular/core';

@Component({
  selector: 'breadcrumb',
  templateUrl: './breadcrumb.template.html',
})
export class BreadcrumbComponent {
  data: any;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/layout/breadcrumb/breadcrumb.component.ts